<template>
  <div class="home_banner" v-if="list!=null">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="like_slide" v-for="(item,index) in list" :key="index">
        <!-- <router-link v-if="item.IsActive" :to="{path:item.ClickUrl}" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'">
        </router-link> -->
        <a :href="item.ClickUrl" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'"></a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';

export default {
  name: 'likeswiper',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      list:null,
      swiperOption: {
        autoplay: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
          }
      }
    }
  },

  created() {
    this.getAdvertisement()
  },
  methods: {
    // 获取广告地址
    getAdvertisement(){
      let that=this;
      let data={PageIndex:1,PageSize:99}
      that.$get(that.$interface.Advertisement,data).then(res=>{
        if(res.Result!=0){
          that.list=res.Data
        }
      })
    }
  }
}

</script>
<style scoped>
.home_banner {
  width: 100%;
  height: 487px;
  overflow: hidden;
  margin: -9px auto 0;
}

.swiper {
  width: 100%;
  height: 487px;
  margin: 0 auto;
}

.like_slide,
.like_slide .bannerDiv {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position:center;
  background-size: 100% auto;
  display: block;
}
/deep/ .swiper-pagination-bullet{
  width: 10px;
  height: 10px;
  opacity: 1;
  background: #ccc;
}
/deep/ .swiper-pagination-bullet-active{
  background: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/swiper/advertisement.vue